import React, { Component } from 'react';
import DocumentTitle from 'react-document-title';
import H5Pay from '../../template/Pay/H5Pay'
import AXIOS from '../../api/axios';
import axios from 'axios';
import { COURSE_URL } from "../../constants";
import { parseQuery } from '../../utils/tools';
import clientApi from '../../api/client';
import UA from '../../utils/ua';

const queryObj = parseQuery(window.location.search.slice(1));
const returnUrl = `https://client.aircourses.com/pay/success`;
const channelList = [
    {num: 1000,string: 'guanwang'},
    {num: 1001,string: 'yingyongbao'},
    {num: 1002,string: '360'},
    {num: 1003,string: 'baidu'},
    {num: 1004,string: 'ali'},
    {num: 1005,string: 'oppo'},
    {num: 1006,string: 'vivo'},
    {num: 1007,string: 'huawei'},
    {num: 1008,string: 'xiaomi'},
    {num: 4000,string: 'Windows'},
];

class H5PayPage extends Component {
    constructor(props){
        super(props);
        if(!(Number(queryObj.channel) > 999)){
            this.index = channelList.findIndex(item => { return item.string === queryObj.channel});
            this.channel = this.index === -1 ? 1000 : channelList[this.index].num;
        }
        else {
            this.channel = queryObj.channel
        }
        this.state = {
            lessonDate: Number(queryObj.lessondate) ? queryObj.lessondate : new Date().getTime()
        }
        this.payTest = this.payTest.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handlePay = this.handlePay.bind(this);
    }
    // 测试支付
    payTest = (isAllow) => {
        if(isAllow){
            AXIOS.payTest({data:{userId:queryObj.stuid,goodsNo:this.state.goodsInfo[queryObj.goodsid].goodsNo}},function(res,err){
            // AXIOS.payTest({data:{userId:queryObj.stuId,goodsNo:'f49323df2c81400abdcd2ba5457949f0'}},function(res,err){
                if(err)alert(err.errorMessage);
                else{
                    const { history } = this.props;
                    clientApi.payResult({payResult:true})                
                    history.replace({
                        pathname: `${COURSE_URL}/success`,
                        search:window.location.search,
                        state:{num:(this.state.goodsInfo[this.state.id].totalAmount)/100}
                    });
                }
            })
        }else alert('请同意用户协议！')
    }
    // 第三方支付下单
    handlePay = (orderNo,channel) => {
        if(channel === 0){ // 微信
            let data = { 
                orderNo:orderNo, 
                payType:'MWEB'
            };
            clearInterval(this.interval);
            AXIOS.payWeixin({ data:data },(res,err) => {
                if (err) alert(err.errorMessage)
                else{
                    const { mwebUrl } = res;
                    if(UA.iosClient){
                        this.interval = setInterval(()=>{
                            this.getOrderStatus();
                            setTimeout(() => {
                                clearInterval(this.interval);
                             }, 60000*2);
                        },4000);
                        window.location.replace(`${mwebUrl}`);
                    }
                    if(UA.androidClient) window.location.replace(`${mwebUrl}&redirect_url=${encodeURIComponent(returnUrl+"?stuid="+queryObj.stuid+"&totalamount="+this.state.totalAmount+"&success=1&type=wait&orderno="+orderNo)}`);
                }
            });
        }else{
            const data = { // 支付宝
                returnUrl:`${returnUrl}?stuid=${queryObj.stuid}&orderno=${orderNo}&totalamount=${this.state.totalamount}&success=1&type=wait`,
                orderNo:orderNo,
                payType: 'QUICK_WAP_PAY'
            };
            axios.post('https://api.aircourses.com/ac-order/alipay',data)
              .then(function (res) {
                document.getElementById('root').innerHTML = res.data;
                setTimeout(()=>{document.forms[0].submit()},500)
              })
              .catch(function (err) {
                alert('error'+JSON.stringify(err));
              });
        }
    }

    // 获取订单号
    handleClick = (isAllow,channel)=>{
        if(isAllow){
            AXIOS.getWxOrder(
                {
                    data:{
                        userId:queryObj.stuid,
                        goodsNo:this.state.goodsInfo[queryObj.goodsid].goodsNo,
                        payType:channel===0?'MWEB':'QUICK_WAP_PAY',
                        channelId:this.channel, // app渠道id
                        version:2 //接口版本
                    }
                },
                (res,err) => {
                if(err) alert('获取订单失败：'+ err.errorMessage)
                else{
                    this.setState({totalAmount:res.totalAmount,orderNo:res.orderNo});
                    this.handlePay(res.orderNo,channel);
                }
            })
        }else alert('请同意用户协议！')
    }
    // 查询订单状态
    getOrderStatus(){
        AXIOS.getOrderStatus({
            query:queryObj.orderno
        },(res,err)=>{
            if(err) console.log(err);
            else{
                if(res.status !== 0){
                    clearInterval(this.interval);         
                    window.location.replace(`${returnUrl}?stuid=${queryObj.stuid}&orderno=${this.state.orderNo}&totalamount=${this.state.totalamount}&success=1&type=wait`)
                }
            }
        })
    }
    componentWillMount(){
        AXIOS.getGoodsInfo({},(res,err) => {
            if(err) console.log(err)
            else{
                this.setState({goodsInfo:res})
            }
        })
    }
    render(){
        return(
            <DocumentTitle title={'支付'}>
                <div className="page_wrap">
                {this.state.goodsInfo && <H5Pay id={queryObj.goodsid} {...this.state} payTest={this.payTest} handleClick={this.handleClick} />}
                </div>
            </DocumentTitle>
        )
    }
}

export default H5PayPage;



// WEBPACK FOOTER //
// ./src/components/payPage/H5PayPage.jsx